import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { AppHelperService } from '../../../app/services/app-helper.service';

@Component({
    selector: 'lti-result-screen',
    templateUrl: './lti-result-screen.template.html',
    styleUrls: ['./lti-result-screen.style.scss'],
    standalone: false
})

export class LtiResultScreen implements OnInit {
  @Input('selectedItemData') selectedItemData: any;
  @Input('bundleDetails') bundleDetails: any;
  spaceId: string;
  classId: string;
  productCode: string;
  remainingAttempts: number;
  productDetails: any;
  isAdultSegment: boolean;

  public imageBasePath: string = IMAGES_BASEPATH;

  constructor(
    private route: ActivatedRoute,
    private appHelperService: AppHelperService) { }

  ngOnInit() {
    this.route.parent.params.subscribe((params: Params) => {
      this.spaceId = params.spaceid;
      this.classId = params.classid;
      this.productCode = params.productcode;
      const attemptsLeft = this.route.snapshot.queryParams['attempts-left'];
      this.remainingAttempts = isNaN(parseInt(attemptsLeft)) ? null : parseInt(attemptsLeft);
      if (this.bundleDetails) {
        this.productDetails = this.bundleDetails.products.find((product) => product['dls-product'] && product['dls-product'].code === this.productCode);
      }
      if (this.productDetails) {
        this.isAdultSegment = !(this.productDetails.segment.segment === 'primary' || this.productDetails.segment.segment === 'secondary');
      }
    });
  }
  navigateToMyHomework() {
    this.appHelperService.navigateToClassApp(['learner', this.spaceId, 'class', this.classId, 'assignments']);
  }
}
